import React ,{Component} from 'react';
import Text, { H3 ,H2} from '@dbk/ui-text';
import { View } from '@dbk/ui-react-utils'
import PropTypes from 'prop-types';

import { InstatntMessenger, PDF, CallBackRequest } from '@dbk/ui-icons';
import { PALETTE,INVESTMENT_CONSTANTS,INVESTMENT_API_CODES, EBANKINGWEBLUX, KEY_CODE } from '../../constants';
// import Button from '../../../components/common/button-view';
import Button from '@dbk/ui-buttons';
//import Popover from '../../../../src/components/popover-component'
import Popover from '../popover-component';
import './style.css';
//import { View, Text, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import {  CloseIcon } from '@dbk/ui-icons';
import { Checkbox, FormGroup, TextInput, Message, Label  } from '@dbk/ui-forms'

// import styles from './styles';
class PopoverMessage extends Component {

  constructor(props){
    super(props);
    this.state = {
      close:true
    };
    this.popoverRef=React.createRef();
    }

  componentDidMount() {
    this.updatePopoverPosition();
    window.addEventListener('resize', this.updatePopoverPosition);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.updatePopoverPosition);
  }

  componentDidUpdate(nextProps){ 
    if(this.props.targetId !== nextProps.targetId){
      this.updatePopoverPosition();
    }
  }

//To Identify the dimentions of tab from it's id and setting position dimentions of popoverTooltip custom component
   updatePopoverPosition=()=>{
    const tabElement=document.getElementById(this.props.targetId);
      if(tabElement){
        const targetRect=tabElement.getBoundingClientRect();
        const popupTip=this.popoverRef.current;
        const scrollY=window.scrollY
        popupTip.style.top=`${targetRect.y+scrollY+targetRect.height-40}px`;
        popupTip.style.left=`${targetRect.x-135}px`;
      }
    }

    popoverContent=(props)=>{
      const {
       title,
       message1,
       message2,
       nextActionLabel,
       detailsActionLabel,
       renderNextButton,
       renderDontShowAgain,
       onDetailsActionClicked,
       onNextActionClicked,
       i18n: { messages }
      } = this.props;

    return( 
     <div onClick={e => e.stopPropagation()}>
       <span className ="popupTip-message">
       <div style={{ whiteSpace: 'pre-line' }}>{message1}</div>
       { message2 && <div style={{paddingTop:'2px'}}>{message2}</div>}
       </span>

        { renderDontShowAgain && <div className ="popupTip-checkbox-container">
        <label className ="popupTip-label-check">
        <input type='checkbox'
          name='show' 
          checked={this.props.alerts.isDontShowAgainCheckbox} 
          onChange={() => this.props.setDontShowAgainCheckbox(!this.props.alerts.isDontShowAgainCheckbox)}
        /> 
        <span className='popupTip-label-check-text'>{messages['app.alerts.dontShowAgain.text']}</span>
        </label>
        </div>}

        <div className ="popupTip-button-container">
        {renderNextButton && <span  className='popupTip-nextButton-container'>
        <Button size="medium" tertiary className="poptip-button poptip-button__next-button" style={{marginRight:'15px'}} onClick={() => onNextActionClicked()}>
          <span className="poptip-button-text">{nextActionLabel}</span>
         </Button>
         </span>}
         <span className="popupTip-detailButton-container"> 
         <Button className="poptip-button" Primary size="medium" onClick={() => onDetailsActionClicked()}>
         <span className="poptip-button-text">{detailsActionLabel}</span>
         </Button>
         </span>
         </div>
    </div>
      );
    }

    render = (props) => {
      const {
        title,
        onPopoverClose,
        closePopover
      } = this.props;
      return (
        <div 
          ref={this.popoverRef}
          className="popupTip-container"
          style={closePopover ? {display: "none"} : {display: "block"}}
        >
         {
          <Popover
            mode="inline"
            orientation="bottom"
            toolTipAlert={true}
            title={title}
            // showOnHover
            popOverClassName='popupTip-content'
           // showCloseButton={true}       // Now not using this close icon as it's colour is grey
            arrowColor={PALETTE.secondaryActive}
            onPopoverClose={onPopoverClose}
            content={this.popoverContent(props)}
            closePopover={closePopover}>  
          </Popover>  
          }       
        </div>
      );
    }
};
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    payments: {
      enablePopUpTab: true,
    },
    alerts: {
      isDontShowAgainCheckbox: true,
    },
    setDontShowAgainCheckbox : { $set: 'alerts.isDontShowAgainCheckbox' }
  },
})(PopoverMessage);


